<script setup lang="ts">
import { computed } from 'vue'
import { XCircleIcon, CheckCircleIcon, InformationCircleIcon, ExclamationTriangleIcon } from '@heroicons/vue/24/outline'

type Type = 'error' | 'success' | 'warning' | 'primary'
interface Props {
    title?: string
    type?: Type
}

const props = withDefaults(defineProps<Props>(), {
    title: undefined,
    type: 'error',
})

const style = computed(() => {
    return {
        'alert--danger': props.type === 'error',
        'alert--success': props.type === 'success',
        'alert--warning': props.type === 'warning',
        'alert--primary': props.type === 'primary',
    }
})
</script>

<template>
    <div class="alert" role="alert" :class="style">
        <div class="alert__container">
            <div class="alert__icon-container">
                <span v-if="type === 'primary'">
                    <slot name="icon-primary">
                        <InformationCircleIcon class="alert__icon" />
                    </slot>
                </span>
                <span v-else-if="type === 'success'">
                    <slot name="icon-success">
                        <CheckCircleIcon class="alert__icon" />
                    </slot>
                </span>
                <span v-else-if="type === 'warning'">
                    <slot name="icon-warning">
                        <ExclamationTriangleIcon class="alert__icon" />
                    </slot>
                </span>
                <span v-else>
                    <slot name="icon-error">
                        <XCircleIcon class="alert__icon" />
                    </slot>
                </span>
            </div>
            <div class="ml-3">
                <h3 v-if="title" class="alert__title">
                    {{ title }}
                </h3>
                <div class="alert__body" :class="{ 'mt-2': !!$slots['title'] }">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>
